import { useQuery } from '@tanstack/react-query';
import { configService } from '../../../services/ConfigService';
import { queryKeys } from '../../../lib/queryKeys';
import { useAuth } from '@/hooks/useAuth';
import { API_CONFIG } from '@/config/api';

export function useEntityTypeWithSchemas(entityType: string) {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: queryKeys.entityTypes.withSchemas(entityType),
    queryFn: () => configService.getEntityTypeWithSchemas(entityType),
    staleTime: API_CONFIG.CACHE_STALE_TIME_MS,
    enabled: Boolean(entityType) && isAuthenticated,
  });
}
